var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"Departure Date","items":_vm.items,"outlined":_vm.outlined,"item-text":"label","item-value":"value","multiple":_vm.multi},on:{"change":_vm.onChange},model:{value:(_vm.departureDate),callback:function ($$v) {_vm.departureDate=$$v},expression:"departureDate"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f867aa8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/templates/builder/TemplateDepartureDateSelect.vue
// module id = null
// module chunks = 